import React, { useState } from 'react';
import PropTypes from 'prop-types';
import shortId from 'shortid';

// Styles
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import { transparentize } from 'polished';

function StyleModeSelector({ className, classes, value, onChange }) {
  const [defaultId] = useState(`mode-${shortId()}`);
  const [customId] = useState(`mode-${shortId()}`);

  return (
    <div className={classNames(classes.root, className)}>
      <div
        className={classes.item}
        onClick={() => onChange('default')}
        onKeyPress={() => onChange('default')}
        role="presentation"
      >
        <input
          id={defaultId}
          type="radio"
          className={classes.radio}
          checked={value === 'default'}
          onChange={() => onChange('default')}
        />
        <label htmlFor={defaultId} className={classes.text}>
          Sift Default
        </label>
      </div>
      <div
        className={classes.item}
        onClick={() => onChange('custom')}
        onKeyPress={() => onChange('custom')}
        role="presentation"
      >
        <input
          id={customId}
          type="radio"
          className={classes.radio}
          checked={value === 'custom'}
          onChange={() => onChange('custom')}
        />
        <label htmlFor={customId} className={classes.text}>
          Custom
        </label>
      </div>
    </div>
  );
}

const styles = theme => {
  return {
    root: {
      display: 'flex',
      '& > *:not(:last-child)': {
        marginRight: theme.spacing(2),
      },
    },
    item: {
      display: 'flex',
      flexDirection: 'column',
      '& > *': {
        flex: '0 0 auto',
      },
      alignItems: 'center',
    },
    radio: {
      marginBottom: theme.spacing(1),
      border: `1px solid ${theme.palette.divider}`,
      width: 24,
      height: 24,
      overflow: 'visible',
      position: 'relative',
      '&:checked': {
        '&::before': {
          backgroundColor: theme.palette.primary.main,
          border: `1px solid ${theme.palette.primary.main}`,
        },
      },
      '&:hover': {
        '&::after': {
          backgroundColor: transparentize(0.8, '#000'),
        },
      },
      '&:focus': {
        '&::after': {
          backgroundColor: transparentize(0.9, '#000'),
        },
      },
      '&::before': {
        borderRadius: 99999,
        backgroundColor: theme.palette.common.white,
        opacity: 1,
        content: "' '",
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        border: `1px solid ${theme.palette.divider}`,
      },
      '&::after': {
        borderRadius: 99999,
        opacity: 1,
        content: "' '",
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      },
    },
    text: {
      ...theme.typography.body1,
      fontWeight: theme.typography.fontWeight.semiBold,
    },
  };
};

StyleModeSelector.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(StyleModeSelector);
